import { useEntitlements } from 'providers/entitlements/EntitlementsProvider';
import { EntitlementKeys } from 'providers/entitlements/types';

/**
 * Single source of truth for whether the current shop should see AI activation
 * surfaces (launchpad guide, dashboard banner, billing-page add-on card, etc.).
 *
 * Resolves the `ai::activation::view` entitlement; the canonical definition
 * lives in the `merchant-entitlements` resolver. See BILL-2588 for the product
 * spec and `merchant-entitlements/entitlement/entitlements.go` for the current
 * resolver criteria — do not duplicate the formula here, as it can be tuned
 * without a frontend change.
 *
 * Fail-closed: shops without the key get `false`.
 */
export const useIsAIActivationEligible = (): boolean => {
  const { isEntitledTo } = useEntitlements();
  return isEntitledTo(EntitlementKeys.AI_ACTIVATION_VIEW);
};
